<div class="payment__plan__container" *ngIf="loaded">
  <div class="payment__plan__title" *ngIf="payment">
    {{ payment.name }}
  </div>
  <div class="sticked">
    <div class="payment__plan__recurring" *ngIf="payment">
      <div class="header">
        <span>{{ payment.plan_components[0].name }}</span>
      </div>
      <span>
        {{ payment.plan_components[0].value | currency:payment.plan_components[0].currency }}
      </span>
      <span style="font-size:1rem;font-weight:normal">
        / {{ payment.plan_components[0].billing_cycle}}
      </span>
    </div>
    <div class="payment__plan__setup" *ngIf="payment && payment.plan_components.length > 1">
      <div class="header" *ngIf="payment.plan_components.length > 1">
        {{ payment.plan_components[1].name }}
      </div>
      <div *ngIf="payment.plan_components.length > 1">
        {{ payment.plan_components[1].value | currency:payment.plan_components[1].currency }}
        <span style="font-size:1rem;font-weight:normal">
        / {{ payment.plan_components[1].billing_cycle}}
        </span>
      </div>
    </div>
    <div class="button text-center mt-3 w-100">
      <button class="btn btn-primary " style="width:100%;" (click)="navigate('checkout')">
        Select
      </button>
    </div>
  </div>
</div>
